import { render, staticRenderFns } from "./FullscreenVideo.vue?vue&type=template&id=2994642c&scoped=true"
import script from "./FullscreenVideo.vue?vue&type=script&lang=js"
export * from "./FullscreenVideo.vue?vue&type=script&lang=js"
import style0 from "./FullscreenVideo.vue?vue&type=style&index=0&id=2994642c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994642c",
  null
  
)

export default component.exports